module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/171.6d2f37db.png";